import { FC } from 'react';
import './style.scss';

const TestSymbol: FC = () => {
  return <div className="test-symbol-component">Test Environment(lemon8.webapp.legal)</div>;
};

export default TestSymbol;
